export function SuccessMessage({ message }: { message: string }) {
  return message ? (
    <p className="text-success-foreground mt-2 text-center">{message}</p>
  ) : null;
}
